module.exports = __webpack_public_path__ + "static/media/1011069.01689ed4.jpg";